import type { ReactElement } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/shared/components/ui";

/**
 * Full-page fail-closed state rendered when the current host looks like an
 * admin host but no admin auth realm is configured. Rendered before any
 * providers mount, so no auth calls or redirects can occur.
 */
export function AdminAccessUnavailablePage(): ReactElement {
  return (
    <main className="clm-page-gutter clm-section-spacing min-h-screen bg-background text-foreground">
      <div className="mx-auto max-w-3xl rounded-lg border bg-card p-8 shadow-sm">
        <h1 className="text-3xl font-bold text-clm-primary-blue">Admin access is not available</h1>
        <p className="mt-4 text-muted-foreground">
          Administrative access is not available in this environment. If you believe you should have
          access, contact support.
        </p>
      </div>
    </main>
  );
}

/**
 * Deny state for `/admin` and `/admin/*` on the standard realm host. Admin
 * tooling is served from a dedicated host; this message intentionally stays
 * generic and does not disclose admin host details.
 */
export function AdminRealmBlockedRoute(): ReactElement {
  return (
    <div className="mx-auto max-w-3xl">
      <Alert variant="destructive">
        {/* Sole heading of this route view: h1 matches the sibling
            AdminAccessUnavailablePage full-page state. */}
        <AlertTitle as="h1">Access denied</AlertTitle>
        <AlertDescription>
          Administrative tools are not available in this application. If you believe you should have
          access, contact support.
        </AlertDescription>
      </Alert>
    </div>
  );
}
